import {  EventEmitter } from '@angular/core';
import { ButtonsActionsTableComponent, CheckTableComponent, ButtonDownloadComponent } from '@app/shared';
import { ButtonDownloadCheckComponent } from '@app/shared/component-table/button-download-check-table.component';

export class DocumentAssessmentConfigService {
  // Se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // Contiene la configuracion de la tabla
  settings = {};
  vista = true;
  generation: true;

  constructor() {
    const self = this;
    this.settings = {
      mode: 'external',
      actions: false,
      noDataMessage: 'No hay valoraciones documentales disponibles',
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        serie: {
          editable: false,
          addable: false,
          title: 'Serie',
          valuePrepareFunction: (cell: any, row: any) => {
                if (row.serie) {
                  return row.serie.codigo + " - "+ row.serie.nombre;
                } else {
                  return null;
                }
              },
          filter: {
            inputClass: 'form-control',
          },
          filterFunction: (cell?: any, search?: string) => {
                if (cell.nombre){
                  return (cell.codigo +" - "+ cell.nombre).toLowerCase().includes(search.toLowerCase()) ? true : false;
                }else{
                  return false;
                }
              }
        },
        subserie: {
          editable: false,
          addable: false,
          title: 'Subserie',
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.subserie) {
              return row.subserie.codigo +" - "+ row.subserie.nombre;
            } else {
              return null;
            }
          },
          filter: {
            inputClass: 'form-control',
          },
          filterFunction: (cell?: any, search?: string) => {
                if (cell.nombre){
                  return (cell.codigo +" - "+ cell.nombre).toLowerCase().includes(search.toLowerCase()) ? true : false;
                }else{
                  return false;
                }
              }
        },
        tipo_documental: {
          editable: false,
          addable: false,
          // valuePrepareFunction: (cell: any, row: any) => {
          //   if (row.tipo_documental) {
          //     return row.tipo_documental.nombre;
          //   } else {
          //     return null;
          //   }
          // },
          title: 'Tipo documental',
          filter: {
            inputClass: 'form-control',
          },
          // filterFunction: (cell?: any, search?: string) => {
          //       if (cell.nombre){
          //         return cell.nombre.toLowerCase().includes(search.toLowerCase()) ? true : false;
          //       }else{
          //         return false;
          //       }
          //     }
        },
        soporte: {
          editable: false,
          addable: false,
          title: 'Soporte',
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.soporte) {
              return row.soporte.nombre;
            } else {
              return null;
            }
          },
          filter: {
            inputClass: 'form-control',
          },
          filterFunction: (cell?: any, search?: string) => {
                if (cell.nombre){
                  return cell.nombre.toLowerCase().includes(search.toLowerCase()) ? true : false;
                }else{
                  return false;
                }
              }
        },
        ag: {
          editable: false,
          addable: false,
          title: 'AG',
          filter: {
            inputClass: 'form-control',
          }
        },
        ac: {
          editable: false,
          addable: false,
          title: 'AC',
          filter: {
            inputClass: 'form-control',
          }
        },
        ct: {
          editable: false,
          addable: false,
          title: 'CT',
          type: 'custom',
          renderComponent: CheckTableComponent,
          filter: {
                inputClass: 'form-control',
                type: 'checkbox',
                config: {
                  true: 'true',
                  false: 'false',
                  resetText: 'Todo',
                },
              }
        },
        e: {
          editable: false,
          addable: false,
          title: 'E',
          type: 'custom',
          renderComponent: CheckTableComponent,
          filter: {
                inputClass: 'form-control',
                type: 'checkbox',
                config: {
                  true: 'true',
                  false: 'false',
                  resetText: 'Todo',
                },
              }
        },
        md: {
          editable: false,
          addable: false,
          title: 'MD',
          type: 'custom',
          renderComponent: CheckTableComponent,
          filter: {
                inputClass: 'form-control',
                type: 'checkbox',
                config: {
                  true: 'true',
                  false: 'false',
                  resetText: 'Todo',
                },
              }
        },
        s: {
          editable: false,
          addable: false,
          title: 'S',
          type: 'custom',
          renderComponent: CheckTableComponent,
          filter: {
                inputClass: 'form-control',
                type: 'checkbox',
                config: {
                  true: 'true',
                  false: 'false',
                  resetText: 'Todo',
                },
              }
        },
        procedimiento: {
          editable: false,
          addable: false,
          title: 'Procedimiento',
          filter: {
            inputClass: 'form-control',
          }
        },
        // rol: {
        //   editable: false,
        //   addable: false,
        //   title: 'Rol',
        //   valuePrepareFunction: (cell: any, row: any) => {
        //     if (row.rol) {
        //       return row.rol.nombre;
        //     } else {
        //       return null;
        //     }
        //   } ,
        //   filter: {
        //     inputClass: 'form-control',
        //   },
        //   filterFunction: (cell?: any, search?: string) => {
        //     if (cell.nombre){
        //       return cell.nombre.toLowerCase().includes(search.toLowerCase()) ? true : false;
        //     }else{
        //       return false;
        //     }
        //   }
        // },
        // consulta: {
        //   editable: false,
        //   addable: false,
        //   title: 'Consulta',
        //   type: 'custom',
        //   renderComponent: CheckTableComponent,
        //   filter: {
        //     inputClass: 'form-control',
        //     type: 'checkbox',
        //     config: {
        //       true: 'true',
        //       false: 'false',
        //       resetText: 'Todo',
        //     },
        //   },
        // },
        id: {
          title: 'Acciones',
          filter: false,
          sort: false,
          type: 'custom',
          renderComponent: ButtonsActionsTableComponent,
          onComponentInitFunction(instance: ButtonsActionsTableComponent) {
            // instance.hidenUpdated = true;
            instance.save.subscribe((data: any) => {
              // Controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      }
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/documents/documentary-assessment/shared/documentary-assessment-config.service.ts